export default __webpack_public_path__ + "static/media/adrian-sabau.4a408b6c.png";